// @flow

import React from 'react'
import styled from 'styled-components'
import ImageGallery from 'lib/ImageGallery'
import OptimizedImage from 'components/atoms/OptimizedImage'
import { imageURLWithTransform } from 'frontend_core/dist/helpers/format'
import { isMobile } from 'common/screen'
import { mediaMax } from 'components/styles/_media'
import { imagePath } from 'frontend_core/dist/helpers/image'

const FlexSlider = styled.div`
  margin: 0;
  padding: 0;
  position: relative;
`

const Slider = FlexSlider.extend`
  margin: 0px auto;
  max-width: 1100px;

  .image-gallery-slide {
    background: none;
  }
  ${mediaMax.desktop`
    width: 100%;
  `};
`

const SlideItem = styled.div`
  display: ${props => props.display};
`

type PropTypes = {
  thumbnails: Array<{
    roomName: string,
    url: string,
    description: string,
  }>,
}

export default class HeadImageSlideShow extends React.Component<*> {
  static convertImageUrl(thumbnail: string, isThumbnail: boolean) {
    if (isThumbnail) {
      return imageURLWithTransform(thumbnail, { width: 219, height: 144 })
    }

    if (isMobile()) {
      return thumbnail
    }

    return imageURLWithTransform(thumbnail, { width: 1200, height: 670 })
  }

  props: PropTypes

  render() {
    const { thumbnails } = this.props

    return (
      <div>
        <Slider>
          <ImageGallery
            items={thumbnails}
            infinite
            lazyLoad
            showPlayButton={false}
            showFullscreenButton={false}
            showThumbnails={false}
            showNav
            useTranslate3D={false}
            slideDuration={100}
            useDefaultStyle
            defaultImage={imagePath('noimage_search.png')}
            renderItem={item => (
              <div className="image-gallery-image">
                <SlideItem>
                  {item.url && (
                    <OptimizedImage
                      src={HeadImageSlideShow.convertImageUrl(item.url, false)}
                      alt={i18n.t('page.room.photoName', {
                        roomName: item.roomName,
                      })}
                    />
                  )}
                </SlideItem>
              </div>
            )}
          />
        </Slider>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/organisms/room/CoverPhotoMobile/index.jsx